// react
import type { ReactNode } from 'react';

// material ui
import { InputLabel } from '@mui/material';
import type { InputLabelProps } from '@mui/material';

export type RHFFieldLabelProps = {
  htmlFor?: string;
  required?: boolean;
  children: ReactNode;
} & Omit<
  InputLabelProps,
  'htmlFor' | 'required' | 'children' | 'shrink' | 'disableAnimation'
>;

// Shared "label above the input" style used by every RHF field wrapper
// (RHFTextField, RHFNumberField, RHFAutocomplete, RHFSelect) instead of a
// floating MUI label. Renders via MUI InputLabel's own `required` prop so
// required fields show the standard asterisk immediately - before the field
// has even been touched - independently of RHF/zod's error state.
export default function RHFFieldLabel({
  htmlFor,
  required,
  children,
  sx,
  ...props
}: RHFFieldLabelProps) {
  return (
    <InputLabel
      htmlFor={htmlFor}
      required={required}
      shrink
      disableAnimation
      sx={{
        display: 'block',
        position: 'static',
        color: 'text.primary',
        transform: 'none',
        fontSize: '0.875rem',
        mb: 1,
        ...sx,
      }}
      {...props}
    >
      {children}
    </InputLabel>
  );
}
